import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Create from "../views/Create.vue";
import Edit from "../views/Edit.vue";
import Contacts from "../views/Contacts.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/create/",
    name: "Create",
    component: Create,

    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Edit.vue"),
  },
  {
    path: "/edit/:id?/",
    name: "Edit",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Edit,

    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Edit.vue"),
  },
  {
    path: "/contacts",
    name: "Contacts",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Contacts,

    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Contacts.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
